import { ComponentStyleConfig } from '@chakra-ui/react';

const defaultButtonStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 'auto',
  textAlign: 'center',
  fontWeight: '400',
  fontSize: '14px',
  color: 'absoluteWhite',
  borderRadius: '50px',
  border: 'none',
  cursor: 'pointer',
  userSelect: 'none',
  outline: 'none',
  boxShadow: 'none',
  textDecoration: 'none',
};

const Button: ComponentStyleConfig = {
  baseStyle: {
    outline: 'none',
    _hover: {
      outline: 'none',
      boxShadow: 'none',
    },
    _focus: {
      outline: 'none',
      boxShadow: 'none',
    },
    _active: {
      outline: 'none',
      boxShadow: 'none',
    },
  },
  sizes: {
    sm: {
      fontSize: '14px',
      px: '0px',
      py: '0px',
    },
    md: {
      fontSize: '14px',
      px: '0px',
      py: '0px',
    },
  },
  variants: {
    primary: {
      ...defaultButtonStyles,
      background: 'poisonGreen',
      color: 'absoluteWhite',
      _disabled: {
        background: 'poisonGreen',
        color: 'absoluteWhite',
        outline: 'none',
        opacity: '0.7',
      },
      _hover: {
        boxShadow: 'none',
        textDecoration: 'none',
        _disabled: {
          background: 'poisonGreen',
          color: 'absoluteWhite',
          outline: 'none',
          opacity: '0.7',
        },
      },
    },
    secondary: {
      ...defaultButtonStyles,
      background: 'mainOrange',
      color: 'dark',
      _disabled: {
        background: 'mainOrange',
        color: 'dark',
        outline: 'none',
        opacity: '1',
      },
      _hover: {
        boxShadow: 'none',
        textDecoration: 'none',
        _disabled: {
          background: 'mainOrange',
          color: 'dark',
          outline: 'none',
        },
      },
    },
    tertiary: {
      ...defaultButtonStyles,
      background: 'darkBlue',
      color: 'absoluteWhite',
      boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
      _disabled: {
        background: 'darkBlue',
        color: 'absoluteWhite',
        outline: 'none',
        opacity: '1',
      },
      _hover: {
        boxShadow: 'none',
        textDecoration: 'none',
        _disabled: {
          background: 'darkBlue',
          color: 'absoluteWhite',
          outline: 'none',
        },
      },
    },
    white: {
      ...defaultButtonStyles,
      background: 'absoluteWhite',
      color: 'dark',
      boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
      _disabled: {
        background: 'absoluteWhite',
        color: 'dark',
        outline: 'none',
        opacity: '1',
      },
      _hover: {
        boxShadow: 'none',
        textDecoration: 'none',
        _disabled: {
          background: 'absoluteWhite',
          color: 'dark',
          outline: 'none',
        },
      },
    },
    ghost: {
      ...defaultButtonStyles,
      _hover: {
        outline: 'none',
        boxShadow: 'none',
        background: 'transparent',
        textDecoration: 'none',
      },
      _focus: {
        outline: 'none',
        boxShadow: 'none',
        background: 'transparent',
      },
      _active: {
        outline: 'none',
        boxShadow: 'none',
        background: 'transparent',
      },
    },
  },
  defaultProps: {
    size: 'md',
    variant: 'ghost',
  },
};

export default Button;
